interface SweetAlertOptions {
  cancelButtonText: string;
  customClass: string;
  showCancelButton: boolean;
  text: string;
  title: string;
  type: string;
  allowOutsideClick?: boolean;
  closeOnConfirm?: boolean;
  confirmButtonText?: string;
  showConfirmButton?: boolean;
}

interface OptionsArguments {
  allowOutsideClick?: boolean;
  cancelButtonText?: string;
  closeOnConfirm?: boolean;
  customClass?: string;
  onLeaveCopy?: string;
  onStayCopy?: string;
  showCancelButton?: boolean;
  showConfirmButton?: boolean;
  successCopy?: string;
  successTitle?: string;
  thingToDelete?: string;
  thingToRemove?: string;
}

export const deleteOptions = (argument?: OptionsArguments): SweetAlertOptions => ({
  cancelButtonText: bfTranslate('Cancel'),
  closeOnConfirm: argument?.closeOnConfirm ?? true,
  confirmButtonText: bfTranslate('Delete'),
  customClass: 'deleting',
  showCancelButton: argument?.showCancelButton ?? true,
  text: `${bfTranslate('Are you sure you want to delete')} ${argument?.thingToDelete ?? ''}?`,
  title: bfTranslate('Are you sure?'),
  type: 'warning',
});

export const removeOptions = (argument?: OptionsArguments): SweetAlertOptions => ({
  cancelButtonText: bfTranslate('Cancel'),
  closeOnConfirm: argument?.closeOnConfirm ?? true,
  confirmButtonText: bfTranslate('Remove'),
  customClass: 'removing',
  showCancelButton: argument?.showCancelButton ?? true,
  text: `${bfTranslate('Are you sure you want to remove')} ${argument?.thingToRemove ?? ''}?`,
  title: bfTranslate('Are you sure?'),
  type: 'warning',
});

export const resetOptions = (argument?: OptionsArguments): SweetAlertOptions => ({
  cancelButtonText: bfTranslate('Cancel'),
  closeOnConfirm: argument?.closeOnConfirm ?? true,
  confirmButtonText: bfTranslate('Reset'),
  customClass: 'resetting',
  showCancelButton: argument?.showCancelButton ?? true,
  text: argument?.thingToDelete ?? '',
  title: bfTranslate('Are you sure?'),
  type: 'warning',
});

export const unsavedChangesOptions = ({
  closeOnConfirm,
  onLeaveCopy = bfTranslate('Discard and Close'),
  onStayCopy = bfTranslate('Continue Editing'),
  showCancelButton,
}: OptionsArguments): SweetAlertOptions => ({
  cancelButtonText: onStayCopy,
  closeOnConfirm: closeOnConfirm ?? true,
  confirmButtonText: onLeaveCopy,
  customClass: 'unsaved-changes',
  showCancelButton: showCancelButton ?? true,
  text: bfTranslate('Are you sure you want to discard changes?'),
  title: bfTranslate('Unsaved Changes'),
  type: 'warning',
});

export const successOptions = ({
  allowOutsideClick = true,
  cancelButtonText = bfTranslate('Close'),
  customClass,
  showCancelButton,
  showConfirmButton,
  successCopy = bfTranslate('Action successfully completed!'),
  successTitle = bfTranslate('Success!'),
}: OptionsArguments): SweetAlertOptions => ({
  type: 'success',
  title: successTitle,
  text: successCopy,
  showCancelButton: showCancelButton ?? true,
  showConfirmButton: showConfirmButton ?? false,
  cancelButtonText,
  allowOutsideClick,
  ...customClass && { customClass },
});

export const mergeAssetOptions = (): SweetAlertOptions => ({
  cancelButtonText: bfTranslate("Don't Merge"),
  confirmButtonText: bfTranslate('Merge'),
  closeOnConfirm: true,
  customClass: 'merging',
  showCancelButton: true,
  text: bfTranslate('There are multiple files with the same filename, do you want them merged together?\n\n'),
  title: bfTranslate('Merge Attachments'),
  type: 'warning',
});
